import CollectionItemDetail from './collection-item-detail.component';

export default CollectionItemDetail;
